import React from 'react';
import PropTypes from 'prop-types';
import NotificationModal from 'bento-ordering/base/components/NotificationModal';

const CheckoutNotPossibleNotification = ({
  closeModal,
  message = 'We encountered an error - please contact the restaurant for more details.',
  fullWidth = false
}) => {
  return (
    <NotificationModal
      title="Could not add to cart"
      body={message}
      onClose={closeModal}
      fullWidth={fullWidth}
    />
  );
};

CheckoutNotPossibleNotification.propTypes = {
  closeModal: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  message: PropTypes.string
};

export default CheckoutNotPossibleNotification;
